import {formatterNum, formatterMoney} from '../utils';
import getUUID from '../getUUID';

// eslint-disable-next-line require-jsdoc
function formatterValue(el, binding, vNode) {
  let ele = el.tagName === 'INPUT' ? el : el.querySelector('input')
  if(!ele){
    return
  }
  let val = '';
  if (vNode.data && vNode.data.model && typeof vNode.data.model.value !== undefined) {
    val = vNode.data.model.value;
  } else {
    val = ele.value;
  }
  val = formatterNum(val);
  ele.value = formatterMoney(val);
  ele.dispatchEvent(new Event('input'))
}


export default {
  inserted: function (el, binding,  vNode) {
    const ele = el.tagName === 'INPUT' ? el : el.querySelector('input');
    if(!ele){
      return
    }
    ele._inputMoneyID = `inputMoney${getUUID()}`;
    ele.addEventListener('blur', ele[ele._inputMoneyID] = () => {
      let val = ele.value;
      const firstLetterIsZero = String(val).startsWith('0');
      const firstLetterIsZeroDot = String(val).startsWith('0.');
      if (firstLetterIsZero && !firstLetterIsZeroDot) {
        val = String(val).slice(1);
      }
      // eslint-disable-next-line no-magic-numbers
      val = formatterNum(val, binding.value || 2);
      ele.value = formatterMoney(val);
      ele.dispatchEvent(new Event('input'));
    });
  },
  bind: (el, binding, vNode) => formatterValue(el, binding, vNode),
  update: (el, binding, vNode) => formatterValue(el, binding, vNode),
  unbind(el) {
    const ele = el.tagName === 'INPUT' ? el : el.querySelector('input');
    if(!ele){
      return
    }
    ele.removeEventListener('blur', ele[ele._inputMoneyID]);
    ele[ele._inputMoneyID] = null;
    delete ele[ele._inputMoneyID];
    ele._inputMoneyID = null;
    delete ele._inputMoneyID;
  }
};
